// Constants
import { WS_TIMEOUT } from 'constants/app.constants';
// Types
import {
  WebsocketTimeoutHandlersReturnType,
  WebsocketTimeoutHandlersType,
} from './types/websocket.timeout.handlers.type';

const wsTimeoutHandler = ({ setError, timeoutRef }: WebsocketTimeoutHandlersType) => {
  clearTimeout(timeoutRef.current);
  setError(true);
};

const finalizeWsHandler = ({
  timeoutRef,
  handleDisconnectWebSocketFromChannelEvent,
}: WebsocketTimeoutHandlersType): void => {
  timeoutRef.current && clearTimeout(timeoutRef.current);
  handleDisconnectWebSocketFromChannelEvent();
};

const startWsTimeoutHandler = ({
  handleDisconnectWebSocketFromChannelEvent,
  setError,
  timeoutRef,
}: WebsocketTimeoutHandlersType) =>
  setTimeout(
    () => {
      wsTimeoutHandler({
        handleDisconnectWebSocketFromChannelEvent,
        setError,
        timeoutRef,
      });
    },
    WS_TIMEOUT,
    []
  );

const WebsocketTimeoutHandlers = (
  props: WebsocketTimeoutHandlersType
): WebsocketTimeoutHandlersReturnType => ({
  handleStartWsTimeout: () => startWsTimeoutHandler(props),
  handleFinalizeWs: () => finalizeWsHandler(props),
});

export { WebsocketTimeoutHandlers };
